import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EsnJobOfferService } from '@core/services/esn-job-offer-service/esn-job-offer.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dossier-candidature',
  templateUrl: './dossier-candidature.component.html',
  styleUrls: ['./dossier-candidature.component.css']
})
export class DossierCandidatureComponent {
  id = this.activatedRoute.snapshot.params['id'];
  iduser = this.activatedRoute.snapshot.params['user_id'];
 

  candidaturedetails:any

  constructor(
    private activatedRoute: ActivatedRoute,
    private jobofferservice: EsnJobOfferService,
    private spinner: NgxSpinnerService,
 
  ) {}
  ngOnInit() {
    this.getcandidaturebyid();

  }

  /* get job offer details */
  getcandidaturebyid() {
    this.spinner.show();
    this.jobofferservice.getcandidatureById(this.iduser,this.id).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        console.log('res detail job offer', res);
        this.candidaturedetails = res.data[0];
       
        console.log('detail job offer', this.candidaturedetails);
      },
      error: () => {},
    });
  }
}
